import React from 'react';
import {NavLink} from 'react-router-dom';
import web from '../img/why3.jpg';

const Aboutus = () =>{
    return(
        <>
                    <section id="aboutus" className="d-flex align-item-center">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-10 mx-auto">
                        <div className="row">
                        <div className="col-md-6 pt-5 pt-md-0 order-2 order-lg-1 d-flex flex-column ">
                            <h1 className="nav_headline " >Supreme BioSolution</h1>
                            <hr style={{"color":"black"}} />
                            <p className="my-3 header_paragraph">
Supreme Biosolution is pioneer in manufacturing of specialty heath care products in the field of aquaculture with the self commitment to provide the best quality to the customers.</p>
                            <div className="mt-3 d-flex justify-content-center">
                            <NavLink to="/about" className="btn-get-started" >
                                    read more
                            </NavLink>
                            </div>
                        </div>
                        <div className="col-lg-6 order-1 order-lg-2 header-img">
                            <img src={web} className="img-fluid animated " alt="front" />
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
    );
};
export default Aboutus;